// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ut1Y","row":"ProcedureTreatmentSummary_row__3PMC6"};